var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGunshotNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFF2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7148 13.3335L20.7148 14.2129",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4736 13.3335L22.4736 14.2129",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8118 16.6533L21.726 16.6533",
    stroke: "#A10505",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0833 15.6743C11.0833 14.7078 11.8668 13.9243 12.8333 13.9243H23.1443C24.1108 13.9243 24.8943 14.7078 24.8943 15.6743V16.3727C24.8943 16.9235 24.635 17.4422 24.1943 17.7727L23.1023 18.5918C22.7993 18.819 22.4309 18.9418 22.0523 18.9418H21.0666H17.9888H16.7277L15.6749 22.8709C15.4247 23.8045 14.4652 24.3585 13.5316 24.1083L13.2096 24.0221C12.276 23.7719 11.722 22.8123 11.9722 21.8788L12.7595 18.9402C11.8272 18.9016 11.0833 18.1336 11.0833 17.1918V15.6743ZM14.2677 18.1918H14.513L13.4211 22.267C13.3853 22.4003 13.4645 22.5374 13.5978 22.5732L13.9198 22.6594C14.0532 22.6952 14.1903 22.616 14.226 22.4827L15.3758 18.1918H15.6261L15.8271 17.4418H17.9888H21.0666H22.0523C22.1064 17.4418 22.159 17.4242 22.2023 17.3918L23.2943 16.5727C23.3573 16.5255 23.3943 16.4514 23.3943 16.3727V15.6743C23.3943 15.5362 23.2824 15.4243 23.1443 15.4243H12.8333C12.6952 15.4243 12.5833 15.5362 12.5833 15.6743V17.1918C12.5833 17.3298 12.6952 17.4418 12.8333 17.4418H13.3721H14.4687L14.2677 18.1918Z",
    fill: "#A10505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2246 21.3425C15.4414 21.4387 15.6813 21.4921 15.9336 21.4921H18.6427C19.3718 21.4921 20.0246 21.04 20.2809 20.3574L20.861 18.8129C20.931 18.6266 20.9652 18.4289 20.9619 18.2299C20.9612 18.1875 20.9589 18.1455 20.9549 18.104H16.0924L16.074 18.1725H19.3786C19.4242 18.1725 19.4614 18.2091 19.4621 18.2547C19.4623 18.2652 19.4605 18.2756 19.4568 18.2855L18.8767 19.83C18.8401 19.9275 18.7468 19.9921 18.6427 19.9921H15.9336C15.796 19.9921 15.6843 19.8809 15.6836 19.7433L15.6831 19.6315L15.2246 21.3425Z",
    fill: "#A10505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGunshotNotifications);
export default __webpack_public_path__ + "static/media/gunshot-notifications.3581d492b4251e50a834db7bf7349b7e.svg";
export { ForwardRef as ReactComponent };